import { FC } from "react";
import colors from "shared/theme/colors";
import styled from "styled-components";

const Badge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  min-width: 44px;
  width: fit-content;
  height: 16px;
  padding: 0 6px;
  border-radius: 1px 12px 12px 1px;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  white-space: nowrap;

  background-color: ${colors.greenHaze};
  color: ${({ theme }) => theme.colorSuccessTextTertiary};
`;

type AffectedTrainBadgeProps = {
  trainId: string;
};

export const AffectedTrainBadge: FC<AffectedTrainBadgeProps> = ({
  trainId,
}) => <Badge>{trainId}</Badge>;
